// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"357eeda0","856":"3deeec28","935":"9c82e783"}[chunkId] + ".js";
};